'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // No error-tracking service wired up yet (Sentry or similar) — this at
    // least gets it into the browser console / Vercel's function logs
    // rather than vanishing silently. Worth replacing with real error
    // reporting once that's set up.
    console.error(error);
  }, [error]);

  return (
    <main style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <section className="card" style={{ padding: '48px 24px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
        <svg width="90" height="108" viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '4px' }}>
          <path d="M32 96 L68 96 L64 114 L36 114 Z" fill="#3d4a3e" opacity="0.9"/>
          <rect x="28" y="91" width="44" height="8" rx="3" fill="#4a5a4c" opacity="0.9"/>
          <rect x="32" y="92" width="36" height="2.5" rx="1" fill="#5a6e5c" opacity="0.5"/>
          <path d="M50 91 Q54 76 48 60 Q44 48 52 34" stroke="#7a8c6e" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.85"/>
          <path d="M50 66 Q30 72 22 88 Q34 84 50 68" fill="#8a9678" opacity="0.7"/>
          <path d="M50 66 Q34 74 25 89" stroke="#6e7a5e" strokeWidth="0.8" strokeLinecap="round" opacity="0.5"/>
          <path d="M50 52 Q68 60 74 76 Q63 70 50 54" fill="#93a082" opacity="0.65"/>
          <path d="M50 52 Q65 62 73 77" stroke="#6e7a5e" strokeWidth="0.8" strokeLinecap="round" opacity="0.45"/>
          <ellipse cx="52" cy="30" rx="10" ry="11" fill="#93a082" opacity="0.9" transform="rotate(8 52 30)"/>
          <ellipse cx="49" cy="27" rx="3" ry="2" fill="#a8b596" opacity="0.4" transform="rotate(-5 49 27)"/>
          <path d="M46 32 Q49 30 52 32" stroke="#3a3f30" strokeWidth="1.2" strokeLinecap="round" fill="none"/>
          <path d="M56 32 Q59 30 62 32" stroke="#3a3f30" strokeWidth="1.2" strokeLinecap="round" fill="none"/>
          <path d="M48 38 Q52 36 56 38" stroke="#3a3f30" strokeWidth="1.1" strokeLinecap="round" fill="none"/>
        </svg>
        <h1 style={{ fontFamily: 'Instrument Serif, serif', fontSize: '24px', color: 'var(--text)' }}>Something went wrong</h1>
        <p style={{ fontSize: '13px', color: 'var(--text-muted)', maxWidth: '340px' }}>
          Not you — something broke on our end. Try again, or head back home.
        </p>
        <div style={{ display: 'flex', gap: '10px', marginTop: '6px' }}>
          <button onClick={() => reset()} className="btn btn-primary" style={{ fontSize: '13px' }}>
            Try again
          </button>
          <Link href="/" className="btn btn-ghost" style={{ textDecoration: 'none', fontSize: '13px' }}>
            ← Back home
          </Link>
        </div>
      </section>
    </main>
  );
}
